export const adds = [
    {
        toBeAdded: 'setUpMock();',
        toBeAddedBefore: 'TestBed.configureTestingModule',
        indent: 12,
        keyword: 'setUpMock();',
        needImportHandler: true
    }
];
